// US phone number formatting for lead capture forms.
// Assumes North American numbers — the lead magnet targets US PM&R residents.

const US_DIGITS = 10;

/**
 * Reduce any input to at most ten significant digits, dropping a leading
 * US country code if one was typed or pasted.
 */
const significantDigits = (value) => {
  if (!value || typeof value !== 'string') return '';
  let digits = value.replace(/\D/g, '');
  if (digits.length > US_DIGITS && digits.charAt(0) === '1') {
    digits = digits.slice(1);
  }
  return digits.slice(0, US_DIGITS);
};

/**
 * Format for display as the user types: (555) 123-4567
 * Partial input formats progressively rather than jumping around.
 */
export const formatPhoneInput = (value) => {
  const digits = significantDigits(value);
  if (digits.length === 0) return '';
  if (digits.length <= 3) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

/** True when the input contains a complete ten-digit US number. */
export const isValidUsPhone = (value) => significantDigits(value).length === US_DIGITS;

/**
 * Convert to E.164 (+15551234567) for storage and SMS delivery.
 * Returns null when the number is incomplete.
 */
export const toE164 = (value) => {
  const digits = significantDigits(value);
  if (digits.length !== US_DIGITS) return null;
  return `+1${digits}`;
};
